import { gql, useMutation, useQuery, useLazyQuery } from '@apollo/client';
import {
  Banner,
  Card,
  ContextualSaveBar,
  Form,
  Frame,
  List,
  Page,
  Spinner,
  Tabs,
  Toast,
  Layout,
  FormLayout,
  TextField,
  Button,
  Badge,
  Icon,
} from '@shopify/polaris';
import { Formik } from 'formik';
import { isEmpty } from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import * as yup from 'yup';

import Billing from './Billing';
import CustomPortal from './CustomPortal';
import Dunning from './Dunning';
import EmailNotification from './EmailNotification';
import HouseKeeping from './HouseKeeping';
import Password from './HouseKeepingComponents/Password';
// import Legal from './Legal';
import ProductExtention from './ProductExtention';
import StoreInfomation from './StoreInformation';
import Translation from './HouseKeepingComponents/Translation';
import Legal from './HouseKeepingComponents/Legal';
//Settings Images
import SettingImage from '../../assets/images/settings/setting.svg';
import BillingImage from '../../assets/images/settings/billing.svg';
import CustomerImage from '../../assets/images/settings/customer.svg';
import DiscountImage from '../../assets/images/settings/discount.svg';
import EmailImage from '../../assets/images/settings/email.svg';
import ExportImage from '../../assets/images/settings/export.svg';
import InformationImage from '../../assets/images/settings/information.svg';
import LegalImage from '../../assets/images/settings/legal.svg';
import PasswordImage from '../../assets/images/settings/password.svg';
import DebugImage from '../../assets/images/settings/code.svg';
import SMSImage from '../../assets/images/settings/sms.svg';
import TranslationImage from '../../assets/images/settings/translation.svg';
import Sms from './HouseKeepingComponents/Sms';
import MainDiscount from './HouseKeepingComponents/DiscountComponents/MainDiscount';
import MainExport from './HouseKeepingComponents/ExportComponents/MainExport';
import ZipCodeImage from '../../assets/images/settings/zip_code.svg';
import ZipCodes from './ZipCodes';
import EnableDebug from './EnableDebug';
import StripeSettings from './StripeSettings';
import DeliveryOption from './DeliveryOption';
import LoadingScreen from '../LoadingScreen';
import SetTimezone from './SetTimezone';
import EmailEditor from 'react-email-editor';

import './settings.scss';
import PlanBilling from '../PlanBilling';
import SetLanguage from './SetLanguage';
import SetCurrency from './SetCurrency';
import { MobileBackArrowMajor } from '@shopify/polaris-icons';
import ManageStaff from '../ManageStaff';
import PaymentSettings from './PaymentSettings';
import ApiAccessToken from './ApiAccessToken';

const Settings = ({
  passwordProtected,
  setPasswordProtected,
  domain,
  i18n,
  shopVersion,
  shopApiData,
  currentPlan,
  setCurrentPlan,
}) => {
  // form data ########################################################
  const [formData, setFormData] = useState(null);
  const [formErrors, setFormErrors] = useState([]);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const hideSaveSuccess = useCallback(() => setSaveSuccess(false), []);
  const validationSchema = yup.object().shape({
    // internalName: yup.string().required().label('Internal name'),
  });

  const confirmPasswordQuery = gql`
    query ($password: String!) {
      confirmPassword(password: $password) {
        success
      }
    }
  `;
  const GET_DATA = gql`
    query {
      fetchSetting {
        paymentRetries
        paymentDelayRetries
        maxFailStrategy
        orderCancelOption
        dayOfProduction
        deliveryIntervalAfterProduction
        eligibleWeekdaysForDelivery
        accountPortalOption
        portalTheme
        activeSubscriptionBtnSeq

        styleAccountProfile
        styleSidebar
        styleSubscription
        styleUpsell
        styleSidebarPages
        navigationDelivery
        deliveryFrequency
        shipingAddress
        upcomingOderDate
        upcomingQuantity
        productToSubscription
        changeVariant
        swapProduct
        shipment
        frequency
        facingFrequencyOption
        oneTimePurchase
        availablePurchase
        discount
        subscriptionCancellation
        cancellationEmailContact
        allowCancelAfter
        plan
        reactiveSubscription
        reasonsCancels {
          id
          title
          returnContent
          _destroy
        }
        emailService
        emailNotifications {
          id
          name
          status
          fromName
          fromEmail
          emailSubject
          emailMessage
          designJson
          slug
          description
          templateType
          locale
        }
        additionalSendAccountAfterCheckout
        bbcStoreowner
        ccStoreowner
        sendShopifyReceipt
        sendFullfillment

        activateDunningForCards
        dunningPeriod
        retryFrequency
        happensToSubscriptions
        happensToInvoices
        activateDunningDirectDebit
        directDebitSubscription
        directDebitInvoice
        dunningOfflineConfigure
        dunningOfflinePeiod
        dunningOfflineSubscription
        dunningOfflineInvoice
        dunningCardConfigure
        chooseAutomaticRetryMode

        storeName
        storeEmail
        storefrontPassword

        checkoutSubscriptionTerms
        emailSubscriptionTerms
        applePaySubscriptionTerms
        showPromoButton
        promoButtonContent
        promoButtonUrl
        contactBoxContent
        promoTagline1Content
        promoTagline2Content

        showSubscription
        showDeliverySchedule
        showOrderHistory
        showAddress
        showBilling
        showAccount
        pauseSubscription
        designType
        showReward
        showTrackOrder

        recurringChargeStatus
        chargeConfirmationLink
      }
    }
  `;
  let { id, tabname, edit_id } = useParams();
  const [getData, { data, loading, error, refetch }] = useLazyQuery(GET_DATA, {
    fetchPolicy: 'network-only',
  });

  const [UPDATE_SETTING, setUpdateSetting] = useState(gql`
    mutation ($input: UpdateSettingInput!) {
      updateSetting(input: $input) {
        setting {
          paymentRetries
          paymentDelayRetries
          maxFailStrategy
          orderCancelOption
          dayOfProduction
          deliveryIntervalAfterProduction
          eligibleWeekdaysForDelivery
          accountPortalOption
          portalTheme
          activeSubscriptionBtnSeq

          styleAccountProfile
          styleSidebar
          styleSubscription
          styleUpsell
          styleSidebarPages
          navigationDelivery
          deliveryFrequency
          shipingAddress
          upcomingOderDate
          upcomingQuantity
          productToSubscription
          changeVariant
          swapProduct
          shipment
          frequency
          facingFrequencyOption
          oneTimePurchase
          availablePurchase
          discount
          subscriptionCancellation
          cancellationEmailContact
          allowCancelAfter
          reactiveSubscription
          emailService
          reasonsCancels {
            id
            title
            returnContent
            _destroy
          }
          additionalSendAccountAfterCheckout
          bbcStoreowner
          ccStoreowner
          sendShopifyReceipt
          sendFullfillment

          activateDunningForCards
          dunningPeriod
          retryFrequency
          happensToSubscriptions
          happensToInvoices
          dunningFutureTrialSubscriptions
          dunningOneTimeInvoice
          activateDunningDirectDebit
          directDebitSubscription
          directDebitInvoice
          dunningOfflineConfigure
          dunningOfflinePeiod
          dunningOfflineSubscription
          dunningOfflineInvoice
          dunningCardConfigure
          chooseAutomaticRetryMode

          storeName
          storeEmail
          storefrontPassword

          checkoutSubscriptionTerms
          emailSubscriptionTerms
          applePaySubscriptionTerms
          showPromoButton
          promoButtonContent
          promoButtonUrl
          contactBoxContent
          promoTagline1Content
          promoTagline2Content

          showSubscription
          showDeliverySchedule
          showOrderHistory
          showAddress
          showBilling
          showAccount
          pauseSubscription
          cancelLater
          pauseLater
          showReward
          showTrackOrder

          designType
        }
      }
    }
  `);

  const [updateSetting] = useMutation(UPDATE_SETTING);

  useEffect(() => {
    if (data) {
      setFormData({ ...data.fetchSetting });
    }
  }, [data]);

  const initialValues = {
    allowCancelAfter: '',
    availablePurchase: '',
    cancellationEmailContact: '',
    changeVariant: '1',
    discount: [],
    emailService: '',
    activeSubscriptionBtnSeq: [
      'update_choices',
      'delivery_schedule',
      'swap_subscription',
      'delay_next_order',
      'edit_subscription',
    ],
    emailNotifications: [
      {
        emailMessage: '',
        emailSubject: '',
        fromEmail: '',
        fromName: '',
        name: 'Subscription Activation',
        slug: 'customer',
        locale: 'en',
        status: true,
        __typename: 'EmailNotification',
      },
      {
        emailMessage: '',
        emailSubject: '',
        fromEmail: '',
        fromName: '',
        name: 'Subscription Activation',
        slug: 'customer',
        locale: 'en',
        status: true,
        __typename: 'EmailNotification',
      },
      {
        emailMessage: '',
        emailSubject: '',
        fromEmail: '',
        fromName: '',
        name: 'Subscription Activation',
        slug: 'store_owner',
        locale: 'en',
        status: true,
        __typename: 'EmailNotification',
      },
      {
        emailMessage: '',
        emailSubject: '',
        fromEmail: '',
        fromName: '',
        name: 'Subscription Activation',
        slug: 'store_owner',
        locale: 'en',
        status: true,
        __typename: 'EmailNotification',
      },
    ],
    facingFrequencyOption: '',
    frequency: '',
    navigationDelivery: 'storeowner_and_customer',
    oneTimePurchase: '',
    paymentDelayRetries: '',
    paymentRetries: '',
    productToSubscription: '',
    reactiveSubscription: 'storeowner_and_customer',
    shipingAddress: 'storeowner_and_customer',
    shipment: 'storeowner_and_customer',
    styleAccountProfile: '',
    styleSidebar: '',
    styleSidebarPages: '',
    styleSubscription: '',
    styleUpsell: '',
    subscriptionCancellation: 'storeowner_and_customer',
    swapProduct: 'storeowner_and_customer',
    themes: '',
    upcomingOderDate: '',
    upcomingQuantity: 'storeowner_and_customer',

    showPromoButton: 'true',
    promoButtonContent: '',
    promoButtonUrl: '',
    contactBoxContent: '',
    promoTagline1Content: '',
    promoTagline2Content: '',

    showSubscription: '',
    showDeliverySchedule: '',
    showOrderHistory: '',
    showAddress: '',
    showBilling: '',
    showAccount: '',

    delayOrder: 'storeowner_and_customer',
    pauseSubscription: 'storeowner_and_customer',
    _destroy: false,
    designType: 'one',
  };
  // form data #####################################################

  const [selectedTitleTab, setSelectedTitleTab] = useState(0);
  const [headerTitle, setHeaderTitle] = useState();
  const [selectedSetting, setSelectedSetting] = useState(
    tabname ? tabname : ''
  );
  const history = useHistory();

  useEffect(() => {
    if (selectedSetting && selectedSetting !== tabname) {
      let toRedirect = edit_id
        ? window.location.pathname
          ?.replace(`/${edit_id}`, '')
          ?.replace(domain?.replace('.myshopify.com', ''), '')
          ?.replace('//', '/')
        : window.location.pathname
          ?.replace(`/${tabname}`, '')
          ?.replace(domain?.replace('.myshopify.com', ''), '')
          ?.replace('//', '/');

      history.push(`${toRedirect}/${selectedSetting}`);
    }
  }, [selectedSetting]);

  const handleBackSetting = useCallback(() => {
    let toRedirect = edit_id
      ? window.location.pathname
        ?.replace(`/${edit_id}`, '')
        ?.replace(domain?.replace('.myshopify.com', ''), '')
        ?.replace('//', '/')
      : window.location.pathname
        ?.replace(`/${tabname}`, '')
        ?.replace(domain?.replace('.myshopify.com', ''), '')
        ?.replace('//', '/');
    history.push(toRedirect);
  }, []);

  // Password confirmation
  const [passwordConfirmed, setPasswordConfirmed] = useState(
    !passwordProtected
  );
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [
    confirmPassword,
    { data: confirmPasswordRes, loading: passwordLoading },
  ] = useLazyQuery(confirmPasswordQuery, { fetchPolicy: 'network-only' });

  const verifyPassword = () => {
    if (!isEmpty(password)) {
      confirmPassword({
        variables: {
          password: password,
        },
      });
    }
  };

  useEffect(() => {
    if (passwordConfirmed) {
      getData();
    }
  }, [passwordConfirmed]);

  useEffect(() => {
    if (confirmPasswordRes?.confirmPassword?.success) {
      setPasswordConfirmed(true);
    } else {
      setPasswordError(confirmPasswordRes?.errors[0]?.message);
    }
  }, [confirmPasswordRes]);

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelectedTitleTab(selectedTabIndex),
    []
  );

  const accessSettings = JSON.parse(localStorage.getItem('accessSettings'));

  const settings = [
    ...(shopVersion !== 'chargezen_lite'
      ? [
        {
          key: 'product_extention',
          title: i18n.t('product_extention'),
          img: SettingImage,
          desc: i18n.t('manage_product_extentions'),
        },
      ]
      : []),
    {
      key: 'email_notification',
      title: i18n.t('email_notifications'),
      img: EmailImage,
      desc: i18n.t('manage_email_sent_to_customers'),
    },
    {
      key: 'timezone',
      title: i18n.t('set_timezone'),
      img: SettingImage,
      desc: i18n.t('manage_the_app_timezone'),
    },
    {
      key: 'currency',
      title: i18n.t('set_currency'),
      img: SettingImage,
      desc: i18n.t('manage_app_currency'),
    },
    {
      key: 'language',
      title: i18n.t('set_language'),
      img: SettingImage,
      desc: i18n.t('manage_app_language'),
    },
    {
      key: 'paymentSetting',
      title: 'Payment Settings',
      img: SettingImage,
      desc: 'Select the payment gateway for your store from here.',
    },
    ...(accessSettings?.manage_staff
      ? [
        {
          key: 'manage_staff',
          title: i18n.t('manage_staff'),
          img: SettingImage,
          desc: i18n.t('manage_your_staff'),
        },
      ]
      : []),

    ...(shopVersion !== 'chargezen_lite'
      ? [
        ...(process.env.APP_TYPE == 'public'
          ? [
            {
              key: 'store_information',
              title: i18n.t('store_information'),
              img: InformationImage,
              desc: i18n.t('manage_information_customers_view_on__store'),
            },
            {
              key: 'discount',
              title: i18n.t('discount'),
              img: DiscountImage,
              desc: i18n.t('enable_manage_store_discount'),
            },
          ]
          : []),
        {
          key: 'billing',
          title: i18n.t('dunning'),
          img: BillingImage,
          desc: i18n.t('manage_billing_information_view_invoices'),
        },
        ...(process.env.APP_TYPE == 'public'
          ? [
            {
              key: 'legal',
              title: i18n.t('legal'),
              img: LegalImage,
              desc: i18n.t('Manage_store_legal_pages'),
              commingSoon: true,
            },
            {
              key: 'export',
              title: i18n.t('export'),
              img: ExportImage,
              desc: i18n.t('export_data_'),
            },
          ]
          : []),
        {
          key: 'sms',
          title: i18n.t('sms'),
          img: SMSImage,
          desc: i18n.t('view_update_store_details'),
        },
        ...(process.env.APP_TYPE == 'public'
          ? [
            {
              key: 'translation',
              title: i18n.t('translation'),
              img: TranslationImage,
              desc: i18n.t('add_change_translations_app'),
            },
          ]
          : []),
        {
          key: 'password',
          title: i18n.t('password'),
          img: PasswordImage,
          desc: i18n.t('manage_your_password_information'),
        },
        {
          key: 'customer-portal',
          title: i18n.t('customer_portal'),
          img: CustomerImage,
          desc: i18n.t('manage_your_customer_subscription_portal'),
        },
        {
          key: 'zip_codes',
          title: i18n.t('zip_codes'),
          img: ZipCodeImage,
          desc: i18n.t('add_cities_zip_Codes'),
        },
        {
          key: 'enable_debug_mode',
          title: i18n.t('enable_debug_mode'),
          img: DebugImage,
          desc: i18n.t('enable_debugging_mode'),
        },
        {
          key: 'stripe_settings',
          title: i18n.t('stripe_settings'),
          img: SettingImage,
          desc: i18n.t('manage_stripe_settings'),
        },
        {
          key: 'delivery_options',
          title: i18n.t('delivery_options'),
          img: DebugImage,
          desc: i18n.t('set_delivery_options'),
        },
      ]
      : []),
    {
      key: 'api_access_token',
      title: i18n.t('api_access_token'),
      img: SettingImage,
      desc: i18n.t('api_access_token_desc'),
    },
    {
      key: 'plan_billing',
      title: i18n.t('plan_billing'),
      img: SettingImage,
      desc: i18n.t('manage_plan_billing'),
    },
  ];

  useEffect(() => {
    if (saveSuccess) {
      setSaveSuccess(false);
    }
  }, [selectedTitleTab]);

  const emailEditorRef = useRef(null);

  return (
    <>
      <Frame>
        {passwordConfirmed ? (
          <Page
            title={
              <div className="back_button_wrapper">
                {selectedSetting ? (
                  <div
                    className="back-button pointer"
                    onClick={handleBackSetting}
                  >
                    <Icon source={MobileBackArrowMajor} color="base" />
                  </div>
                ) : (
                  ''
                )}
                <div class="text_wrapper">
                  {headerTitle
                    ? headerTitle
                    : selectedSetting
                      ? settings?.find((s) => s.key === selectedSetting)?.title
                      : i18n.t('settings')}
                </div>
              </div>
            }
          >
            {loading && (
              <Card>
                <LoadingScreen />
              </Card>
            )}
            {formErrors.length > 0 && (
              <>
                <Banner
                  title={i18n.t('setting_could_not_be_saved')}
                  status="critical"
                >
                  <List type="bullet">
                    {formErrors.map((message, index) => (
                      <List.Item key={index}>{message.message}</List.Item>
                    ))}
                  </List>
                </Banner>
                <br />
              </>
            )}
            {formData && selectedSetting != 'plan_billing' ? (
              <Formik
                validationSchema={validationSchema}
                initialValues={formData ? formData : initialValues}
                enableReinitialize
                onSubmit={(
                  values,
                  { setSubmitting, setDirty, resetForm, touched }
                ) => {
                  const newValues = {
                    ...values,
                    navigationDelivery:
                      values.navigationDelivery || 'storeowner_and_customer',
                    reactiveSubscription:
                      values.reactiveSubscription || 'storeowner_and_customer',
                    shipingAddress:
                      values.shipingAddress || 'storeowner_and_customer',
                    shipment: values.shipment || 'storeowner_and_customer',
                    subscriptionCancellation:
                      values.subscriptionCancellation ||
                      'storeowner_and_customer',
                    swapProduct:
                      values.swapProduct || 'storeowner_and_customer',
                    upcomingQuantity:
                      values.upcomingQuantity || 'storeowner_and_customer',
                    delayOrder: values.delayOrder || 'storeowner_and_customer',
                    pauseSubscription:
                      values.pauseSubscription || 'storeowner_and_customer',
                  };
                  delete newValues?.recurringChargeStatus;
                  delete newValues?.chargeConfirmationLink;
                  delete newValues?.plan;

                  updateSetting({ variables: { input: { params: newValues } } })
                    .then((resp) => {
                      const data = resp.data;
                      const errors = data.errors;

                      if (errors) {
                        setFormErrors(errors);
                      } else {
                        setSaveSuccess(true);
                        console.log('oke');
                        refetch();
                        setDirty(false);
                        // resetForm({});
                        console.log('kxjckxjck');
                      }

                      setSubmitting(false);
                    })
                    .catch((error) => {
                      setSubmitting(false);
                      setFormErrors(error);
                    });
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  resetForm,
                  dirty,
                  setDirty,
                  formik,
                  /* and other goodies */
                }) => (
                  <Form onSubmit={handleSubmit}>
                    {dirty && (
                      <ContextualSaveBar
                        alignContentFlush={true}
                        message={i18n.t('unsaved_changes')}
                        saveAction={{
                          onAction: () => handleSubmit(),
                          loading: isSubmitting,
                          disabled: false,
                        }}
                        discardAction={{
                          onAction: resetForm,
                        }}
                      />
                    )}

                    {saveSuccess && (
                      <Toast
                        content={i18n.t('setting_is_saved')}
                        onDismiss={hideSaveSuccess}
                      />
                    )}
                    <>
                      {/* new settings bar */}
                      <div className="settings-container">
                        {!selectedSetting && (
                          <>
                            <div>
                              <Card>
                                <Card.Section>
                                  <div class="setting-grid">
                                    {settings.map((setting) => (
                                      <div
                                        key={Math.random()}
                                        class="tabs-parents pointer"
                                        onClick={() =>
                                          !setting.commingSoon &&
                                          setSelectedSetting(setting.key)
                                        }
                                      >
                                        <div class="icon-sec">
                                          <img src={setting.img} />
                                        </div>
                                        <div class="tab-info">
                                          <h4>
                                            {setting.title}
                                            {setting.commingSoon && (
                                              <Badge status="attention">
                                                {i18n.t('comming_soon')}
                                              </Badge>
                                            )}
                                          </h4>
                                          <p>{setting.desc}</p>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </Card.Section>
                              </Card>
                            </div>
                          </>
                        )}
                        {/* settings layout */}
                        {selectedSetting && (
                          <>
                            {selectedSetting === 'house_keeping' ? (
                              <HouseKeeping i18n={i18n} />
                            ) : selectedSetting === 'billing' ? (
                              <Billing
                                i18n={i18n}
                                values={values}
                                touched={touched}
                                errors={errors}
                                setFieldValue={setFieldValue}
                                handleBack={handleBackSetting}
                              />
                            ) : selectedSetting === 'customer-portal' ? (
                              <CustomPortal
                                i18n={i18n}
                                values={values}
                                touched={touched}
                                errors={errors}
                                setFieldValue={setFieldValue}
                                handleSubmit={handleSubmit}
                                refetch={refetch}
                                isSubmitting={isSubmitting}
                                handleBack={handleBackSetting}
                                domain={domain}
                              />
                            ) : selectedSetting === 'email_notification' ? (
                              <div className="EmailNotification">
                                <EmailNotification
                                  i18n={i18n}
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  handleSubmit={handleSubmit}
                                  handleBack={handleBackSetting}
                                  setUpdateSetting={setUpdateSetting}
                                  {...{ headerTitle, setHeaderTitle, domain }}
                                />
                              </div>
                            ) : selectedSetting === 'timezone' ? (
                              <div className="TimeZone">
                                <SetTimezone
                                  i18n={i18n}
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  handleSubmit={handleSubmit}
                                  handleBack={handleBackSetting}
                                  setUpdateSetting={setUpdateSetting}
                                />
                              </div>
                            ) : selectedSetting === 'currency' ? (
                              <div className="Currency">
                                <SetCurrency
                                  i18n={i18n}
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  handleSubmit={handleSubmit}
                                  handleBack={handleBackSetting}
                                  setUpdateSetting={setUpdateSetting}
                                />
                              </div>
                            ) : selectedSetting === 'language' ? (
                              <div className="Language">
                                <SetLanguage
                                  i18n={i18n}
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  handleSubmit={handleSubmit}
                                  handleBack={handleBackSetting}
                                  setUpdateSetting={setUpdateSetting}
                                />
                              </div>
                            ) : selectedSetting === 'paymentSetting' ? (
                              <div className="paymentSetting">
                                <PaymentSettings
                                  i18n={i18n}
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  handleSubmit={handleSubmit}
                                  handleBack={handleBackSetting}
                                  setUpdateSetting={setUpdateSetting}
                                />
                              </div>
                            ) : selectedSetting === 'manage_staff' ? (
                              <ManageStaff
                                i18n={i18n}
                                values={values}
                                touched={touched}
                                errors={errors}
                                setFieldValue={setFieldValue}
                                handleSubmit={handleSubmit}
                                handleBack={handleBackSetting}
                              />
                            ) : selectedSetting === 'store_information' ? (
                              <StoreInfomation
                                i18n={i18n}
                                values={values}
                                touched={touched}
                                errors={errors}
                                setFieldValue={setFieldValue}
                                handleSubmit={handleSubmit}
                                handleBack={handleBackSetting}
                                shopApiData={shopApiData}
                                domain={domain}
                                currentPlan={currentPlan}
                                setCurrentPlan={setCurrentPlan}
                              />
                            ) : selectedSetting === 'product_extention' ? (
                              <div className="storeInfomation">
                                <ProductExtention
                                  i18n={i18n}
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  handleSubmit={handleSubmit}
                                  handleBack={handleBackSetting}
                                />
                              </div>
                            ) : selectedSetting === 'discount' ? (
                              <>
                                <MainDiscount
                                  i18n={i18n}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : selectedSetting === 'export' ? (
                              <>
                                <MainExport
                                  i18n={i18n}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : selectedSetting === 'zip_codes' ? (
                              <>
                                <ZipCodes
                                  i18n={i18n}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : selectedSetting === 'enable_debug_mode' ? (
                              <>
                                <EnableDebug
                                  i18n={i18n}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : selectedSetting === 'stripe_settings' ? (
                              <>
                                <StripeSettings
                                  i18n={i18n}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : selectedSetting === 'sms' ? (
                              <>
                                <Sms
                                  i18n={i18n}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : selectedSetting === 'legal' ? (
                              <>
                                <Legal
                                  i18n={i18n}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : selectedSetting === 'translation' ? (
                              <>
                                <Translation
                                  i18n={i18n}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : selectedSetting === 'password' ? (
                              <>
                                <Password
                                  i18n={i18n}
                                  handleBack={handleBackSetting}
                                  passwordProtected={passwordProtected}
                                  setPasswordProtected={setPasswordProtected}
                                />
                              </>
                            ) : selectedSetting === 'api_access_token' ? (
                              <>
                                <ApiAccessToken
                                  i18n={i18n}
                                  values={values}
                                  domain={domain}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : selectedSetting === 'delivery_options' ? (
                              <>
                                <DeliveryOption
                                  i18n={i18n}
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  setFieldValue={setFieldValue}
                                  handleBack={handleBackSetting}
                                />
                              </>
                            ) : (
                              ''
                            )}
                          </>
                        )}
                      </div>
                    </>
                  </Form>
                )}
              </Formik>
            ) : (
              selectedSetting === 'plan_billing' && (
                <div className="plan_billing_wrapper">
                  <Layout>
                    <Layout.Section>
                      <PlanBilling
                        i18n={i18n}
                        domain={domain}
                        {...{ currentPlan, setCurrentPlan }}
                      />
                    </Layout.Section>
                  </Layout>
                </div>
              )
            )}
          </Page>
        ) : (
          <Page title="Password protected">
            <Layout>
              <Layout.Section>
                <Card sectioned>
                  <FormLayout>
                    <TextField
                      value={password}
                      onChange={(value) => setPassword(value)}
                      label={i18n.t('password')}
                      type="password"
                      error={passwordError && passwordError}
                    />
                    <Button
                      primary
                      loading={passwordLoading}
                      onClick={verifyPassword}
                    >
                      {i18n.t('confirm')}
                    </Button>
                  </FormLayout>
                </Card>
              </Layout.Section>
            </Layout>
          </Page>
        )}
      </Frame>
    </>
  );
};

export default Settings;
